import { type ChangeEvent, type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import Config, { type MultiLang } from '../config';
import ItemUtil from '../database/lib/ItemUtil';
import Functions from '../functions';

interface Props {
    lang: MultiLang;
}

const Header = (props: Props) => {
    const { lang } = props;
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');

    const handleChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
        setKeyword(event.target.value);
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (keyword.trim() !== '') {
            void navigate(ItemUtil.getSearchByKeywordUrl('all', keyword));
        }
    };

    const title = Functions.mlang(Config.SITE_TITLE, lang);
    return (
        <div id="header">
            <div className="r_back">
                <div className="logo">
                    <Link to="/" title={title} className="go_home">
                        <span className="hidden">{title}</span>
                    </Link>
                    <a
                        className="go_jnode"
                        href="https://www.neuroinf.jp/"
                        title="INCF Japan Node Portal Site"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="hidden">INCF Japan Node Portal Site</span>
                    </a>
                    <div className="search_box">
                        <form onSubmit={handleSubmit}>
                            <input type="text" value={keyword} onChange={handleChangeKeyword} />
                            &nbsp;&nbsp;
                            <input className="formButton" type="submit" value="Search" />
                            &nbsp;&nbsp;
                            <Link to="/database/advanced">
                                {Functions.mlang('[en]Advanced[/en][ja]詳細検索[/ja]', lang)}
                            </Link>
                        </form>
                    </div>
                    <div className="sub">
                        <div className="menu" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
